// extracted by mini-css-extract-plugin
module.exports = {"notice":"ClosureNotice_notice__uZ6p4","icon":"ClosureNotice_icon__UeMVi","body":"ClosureNotice_body__w_jKz"};